import { useEffect, useState } from "react";
import { useProducts } from "../../../../stores/useProducts";
import { CheckboxList } from "../../../general/customInputs/CheckboxList";
import SearchInput from "../../../general/SearchInput";

import {
  HeaderOptionsSection,
  DownloadUploadOptions,
  SelectAllButton,
} from "./HeaderOptions.styles";
import CustomButton from "../../../general/CustomButton";

import { GetProviderTemplateURL } from "../../../../services/massive-upload/massive-upload.service";

export function HeaderOptions({
  productsChecked = {},
  allChecked = false,
  setCategoriesSelected = () => {},
  setAllChecked = () => {},
  setPreviousViewActive = () => {},
  setXlsFile = () => {},
  addNotification = (type, message, duration) => {},
}) {
  const { products, massiveProducts, setMassiveProducts } = useProducts();
  const [categories, setCategories] = useState([]);

  const setCategoriesAvailable = () => {
    const categories = new Set();

    massiveProducts.forEach((product) => {
      if (product?.stage !== null) return;

      categories.add(
        JSON.stringify({
          category_id: product.article.id_category,
          category: product.article.category,
        })
      );
    });

    setCategories(
      Array.from(categories).map((category) => JSON.parse(category))
    );
  };

  async function handleDownloadTemplate() {
    const products = Object.values(productsChecked)
      .filter((product) => product.checked)
      .map((product) => ({
        upc: product.upc,
        category_id: product.category_id,
      }));

    const response = await GetProviderTemplateURL({
      products,
    });

    if (response.error) {
      console.log("Error downloading template:", response.error);
      return;
    }

    if (!response.url)
      return console.error("No se encontró la URL de descarga");

    const link = document.createElement("a");
    link.href = response.url;
    link.download = "onboarding_provider_template";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    setCategoriesAvailable();
  }, [massiveProducts]);

  return (
    <HeaderOptionsSection>
      {/* Agregamos las opciones de busqueda y filtrado */}

      <div>
        {/* Input de busqueda de producto */}

        <SearchInput placeholder="Buscar producto" onChange={(event) => {

          const searchTerm = event.target.value.toLowerCase();

          const filteredProducts = products.filter((product) => {
            const productName = product?.article?.name?.toLowerCase() || "";
            const productUpc = product?.article?.upc?.toLowerCase() || "";
            return (
              (productName.includes(searchTerm) ||
              productUpc.includes(searchTerm)) && product.percentage <= 17
            );
          });

          setMassiveProducts(filteredProducts);

        }} />

        <CheckboxList
          id="categories-list"
          value={categories.map((category) => category.category_id)}
          defaultOption="Todas las categorías"
          name="Todas las categorías"
          placeholder="Buscar categorías"
          items={categories.map((category) => ({
            label: category.category,
            value: category.category_id,
          }))}
          onChange={(selected) => {
            setCategoriesSelected(selected);
          }}
        />

        <label htmlFor="select-all">
          <SelectAllButton>
            <input
              type="checkbox"
              name="select-all"
              id="select-all"
              checked={allChecked}
              onChange={(e) => {
                setAllChecked((prev) => (prev ? false : true));
              }}
            />

            <p>Seleccionar todos</p>
          </SelectAllButton>
        </label>
      </div>

      <DownloadUploadOptions>
        {/* Creamos los botones de carga y descarga de plantilla */}
        <CustomButton
          icon="file_upload"
          variant="gray"
          iconOnly={true}
          type="file"
          onFileChange={(event) => {
            if (!event.target.files[0]) return setPreviousViewActive(false);

            setXlsFile(event.target.files[0]);
            setPreviousViewActive(true);
          }}
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          className="button"
        />
        <CustomButton
          icon="file_download"
          variant="gray"
          iconOnly={true}
          onClick={() => {
            addNotification(
              "info",
              "Se ha iniciado la descarga de tu plantilla, por favor espere...",
              6000
            );
            handleDownloadTemplate().catch((error) => {
              addNotification("error", error, 6000);
            });
          }}
          showTooltip={true}
          tooltipText="Descarga la plantilla"
          className="button"
          disabled={
            Object.values(productsChecked).filter((product) => product.checked)
              .length === 0
          }
        />
      </DownloadUploadOptions>
    </HeaderOptionsSection>
  );
}
